import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({
    token: localStorage.getItem('jwtToken'),
    club: JSON.parse(localStorage.getItem('clubData')) || null,
  });

  useEffect(() => {
    if (auth.token) {
      localStorage.setItem('jwtToken', auth.token);
      localStorage.setItem('clubData', JSON.stringify(auth.club));
    } else {
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('clubData');
    }
  }, [auth]);

  const login = (token, club) => {
    setAuth({ token, club });
  };

  const logout = () => {
    setAuth({ token: null, club: null });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
